"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var alwaysNumber_1 = __importDefault(require("./alwaysNumber"));
/**
 * Rounds a given number to the specified decimal precision.
 *
 * @example
 * import roundNumber from '@carvana/futilities/roundNumber';
 * roundNumber(17.33)
 * // () => 17
 * roundNumber(17.33333, 2)
 * // () => 17.33
 */
function roundNumber(value, precision) {
    if (value === void 0) { value = 0; }
    if (precision === void 0) { precision = 0; }
    return Number(Math.round(parseInt(alwaysNumber_1.default(value) * 100 + "e" + precision, 10)) + "e-" + precision);
}
exports.default = roundNumber;
//# sourceMappingURL=roundNumber.js.map